import { fileExtension } from '../mediaViewer/mediaFileTypes';

export function isPdfFile(fileName: string): boolean {
  return fileExtension(fileName) === 'pdf';
}

export function isPreviewablePdf(fileName: string): boolean {
  return isPdfFile(fileName);
}
